import { range } from 'lodash';
import React from 'react';
import { FormSelect, FormCheck, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { getTrainerResults, reset, setIntl, setOptimized, setRank } from './weaveTrainerSlice';
import { show as showLoad } from './weaveLoadSlice';
import { show as showSave } from './weaveSaveSlice';
import { show as showShare } from './weaveShareSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const ints = range(12, 19 + 1);
const ranks = range(0, 12 + 1);

function WeaveTrainerHeader() {
  const dispatch = useAppDispatch();
  const intl = useAppSelector(state => state.weaveTrainer.intl);
  const rank = useAppSelector(state => state.weaveTrainer.rank);
  const optimized = useAppSelector(state => state.weaveTrainer.optimized);

  const handleIntlChange = (value: string) =>  {
    dispatch(setIntl(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleRankChange = (value: string) =>  {
    dispatch(setRank(parseInt(value)));
    dispatch(getTrainerResults());
  }

  const handleOptimizedChange = (value: boolean) =>  {
    dispatch(setOptimized(value));
    dispatch(getTrainerResults());
  }

  return (
    <div className="weave-trainer-header">
      <div className="me-2">
        <label className="small">Int</label>
        <FormSelect className="w-auto" size="sm" aria-label="Intelligence" value={intl} onChange={e => handleIntlChange(e.target.value)}>
          {ints.map(x => <option key={x} value={x}>{x}</option>)}
        </FormSelect>
      </div>

      <div className="me-3">
        <label className="small">Rank</label>          
        <div className="d-flex align-items-center">
          <FormSelect className="w-auto me-1" size="sm" aria-label="Rank" value={rank} onChange={e => handleRankChange(e.target.value)}>
            {ranks.map(x => <option key={x} value={x}>{x}</option>)}
          </FormSelect>
          <OverlayTrigger overlay={<Tooltip style={{position: 'fixed'}}><small>Do not set rank unless you are White Tower, Kin, or Dreadlord. Dreadlords must add +3 to rank.</small></Tooltip>}>
            <FontAwesomeIcon icon={faCircleInfo} tabIndex={0} />
          </OverlayTrigger>
        </div>
      </div>

      {/*<div className="me-2">
        <label className="small">Clan</label>
        <FormSelect className="race" size="sm" aria-label="Race" value={undefined}>
          <option>-</option>
          <option>Tower</option>
          <option>Kin</option>
          <option>Dreadlord</option>
          <option>Other</option>
        </FormSelect>
      </div>*/}

      <div className="me-2">
        <label className="small">&nbsp;</label>
        <Button className="btn-reset1 me-2" size="sm" variant="primary" onClick={() => dispatch(reset())}>Reset</Button>
        <Button className="btn-save1 me-2" size="sm" variant="primary" onClick={() => dispatch(showSave())}>Save</Button>
        <Button className="btn-load1 me-2" size="sm" variant="primary" onClick={() => dispatch(showLoad())}>Load</Button>
        <Button className="btn-share1 me-0" size="sm" variant="primary" onClick={() => dispatch(showShare())}>Share</Button>
      </div>

      <div className="ms-lg-auto text-center">
        <label className="small ms-0">Optimized</label>
        <FormCheck type="switch" className="my-switch" checked={optimized} onChange={e => handleOptimizedChange(e.target.checked)} />
      </div>
    </div>
  );
}

export default WeaveTrainerHeader;